import React, { useMemo } from "react";
import {
  EMPTY_ARRAY_LENGTH,
  questionsAverageRatingCardConstants,
} from "../../../../constants";

const {
  SURVEY_QUESTIONS,
  GROUP_AVERAGE,
  STORE_AVERAGE,
  PREVIOUS,
  DAYS,
  QUESTION,
  NO_RATING,
  IN_STORE,
  ARCHIVED_QUESTIONS,
} = questionsAverageRatingCardConstants;

const QuestionAverageRatingRow = ({ question, index }) => {
  const isImproved =
    question?.averageRating > question?.previousAverageRating;

  return (
    <div className="row mt-2">
      <div className="col-6">
        <p>
          <b>{`${QUESTION} ${index + 1}: `}</b>
          {question?.transactionQuestion || question?.sentimentQuestion}
        </p>
      </div>
      <div className="col-3">
        <div className="d-flex align-items-center mb-2 justify-content-center">
          <div
            className={`fw-900 pe-1 ${
              isImproved ? "sms-delivered" : "unique-coupons-issued"
            }`}
          >
            •
          </div>
          <div>
            {question?.averageRating ? question?.averageRating : NO_RATING}
          </div>
        </div>
      </div>
      <div className="col-3 text-center">
        <p>
          {question?.previousAverageRating
            ? question?.previousAverageRating
            : NO_RATING}
        </p>
      </div>
    </div>
  );
};

const QuestionsAverageRating = (surveyQuestions) => {
  const { questions } = surveyQuestions;

  const posQuestions =
    questions?.filter((q) => q.isPOSQuestion === false) || [];
  const inStoreQuestions =
    questions?.filter((q) => q.isPOSQuestion === true) || [];

  return (
    <div>
      {posQuestions.map((question, index) => (
        <QuestionAverageRatingRow
          key={question.questionNumber}
          question={question}
          index={index}
        />
      ))}
      <hr />

      {/* Conditionally render In-Store section */}
      {inStoreQuestions.length > EMPTY_ARRAY_LENGTH && (
        <>
          <h4 className="text-danger text-center">{IN_STORE}</h4>
          <hr />
          <div className="mt-4">
            {inStoreQuestions.map((question, index) => (
              <QuestionAverageRatingRow
                key={question.questionNumber}
                question={question}
                index={index}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export const QuestionsAverageRatingCard = ({
  isGroup,
  dayCounts,
  surveyQuestionsAverageDetails,
}) => {
  const surveyQuestions = useMemo(() => {
    if (surveyQuestionsAverageDetails) {
      return surveyQuestionsAverageDetails?.filter((f) => !f.isArchived);
    } else {
      return [];
    }
  }, [surveyQuestionsAverageDetails]);

  const archivedQuestions = useMemo(() => {
    if (surveyQuestionsAverageDetails) {
      return surveyQuestionsAverageDetails?.filter((f) => f.isArchived);
    } else {
      return [];
    }
  }, [surveyQuestionsAverageDetails]);

  return (
    <div className="card shadow status-response-card w-100 card-size">
      <div className="card-body px-3 pb-0 mx-0">
        {/* Headings */}
        <div className="row fw-bold">
          <div className="col-6">
            <div className="mt-3">
              <p>{SURVEY_QUESTIONS}</p>
            </div>
          </div>
          <div className="col-3 text-center">
            <div className="mt-3">
              <p>{isGroup ? GROUP_AVERAGE : STORE_AVERAGE}</p>
            </div>
          </div>
          <div className="col-3 text-center">
            <div className="mt-3">
              <p>{`${PREVIOUS} ${dayCounts} ${DAYS}`}</p>
            </div>
          </div>
        </div>
        {/* Content */}
        <QuestionsAverageRating questions={surveyQuestions} />
        {archivedQuestions.length > EMPTY_ARRAY_LENGTH && (
          <>
            <hr />
            <p className="fw-bold text-center">{ARCHIVED_QUESTIONS}</p>
            <hr />
            <QuestionsAverageRating questions={archivedQuestions} />
          </>
        )}
      </div>
    </div>
  );
};
